import Make from './make'

const make = Make('auth/')

interface Policy {
  username: string
}

export const getPolicy = async (data: Policy): Promise<any> => {
  const req = await make.post({
    endpoint: 'policy',
    data,
  })

  // if (!req.success) {
  // return false
  // }

  return req
}

interface Link {
  email: string
  nonce: string
  state: string
}

export const createO365LoginLink = async (data: Link): Promise<any> => {
  const req = await make.post({
    endpoint: 'create-o365-login-link',
    data,
  })

  if (!req.success) {
    return false
  }

  return req
}

export const createGoogleLoginLink = async (data: Link): Promise<any> => {
  const req = await make.post({
    endpoint: 'create-gsuite-login-link',
    data,
  })

  if (!req.success) {
    return false
  }

  return req
}

interface GoogleData {
  code: string
  googleKey?: string
  nonce: string
}

export const loginGoogleSSO = async (data: GoogleData) => {
  const req = await make.post<{ state: string }>({
    endpoint: `gsuite-login`,
    data,
  })

  return req
}

interface MicrosoftData {
  id_token: string
  microsoftKey?: string
  nonce: string
}

export const loginMicrosoftSSO = async (data: MicrosoftData) => {
  const req = await make.post<{ state: string }>({
    endpoint: `o365-login`,
    data,
  })

  return req
}
